import { MetricConfiguration, MetricConfigurationUnitType } from 'areas/metrics/components/MetricSelector/types';
import { MetricInfo } from 'framework/entities/metricInfo';

import { MetricPayload } from 'areas/metrics/api';

type UnitOrConversion = {
	conversionUnit?: string;
	conversion?: string;
	customUnit?: string;
};

export function getUnitOrConversion(metricConfiguration: MetricConfiguration) {
	const result: UnitOrConversion = {};

	if (metricConfiguration.unit == MetricConfigurationUnitType.Custom) {
		result.conversion = metricConfiguration.formula;
		result.customUnit = metricConfiguration.unitLabel;
	} else if (metricConfiguration.unit != MetricConfigurationUnitType.Autoscaling) {
		result.conversionUnit = metricConfiguration.unit;
	}

	return result;
}
